import { sleep } from '../../../../../utils';

export async function insertVariable(variable, FIELDS, FIELDS_REF) {
  let { value } = this.focusedElement || {};
  if (value == null) {
    this.$emit('show-snackbar');
    return;
  }
  const startIndex = this.focusedElement.selectionStart;
  const endIndex = this.focusedElement.selectionEnd;
  const firstPartOfText = value.slice(0, startIndex);
  const lastPartOfText = value.slice(endIndex);
  const field = FIELDS_REF ?? FIELDS[this.focusedRef];

  value = `${firstPartOfText}${variable}${lastPartOfText}`;
  this[field] = value;
  await sleep(160);
  this.focusedElement.setSelectionRange(
    firstPartOfText.length,
    firstPartOfText.length + variable.length
  );
  this.focusedElement.focus();
  this.emitData();
}

export const addTextToElement = (insertText) => {
  const selection = document.getSelection();
  const range = selection.getRangeAt(0);
  const originalContent = selection.focusNode.textContent;
  const originalStart = range.startOffset;
  const originalEnd = range.endOffset;

  const front = originalContent.substring(0, originalStart);
  const back = originalContent.substring(originalEnd, originalContent.length);
  const repTxt = front + insertText + back;
  if (selection.focusNode.innerHTML) {
    selection.focusNode.innerHTML = selection.focusNode.innerHTML.replace(
      selection.focusNode.textContent,
      repTxt
    );
  } else {
    selection.focusNode.parentElement.innerHTML =
      selection.focusNode.parentElement.innerHTML.replace(
        selection.focusNode.textContent,
        repTxt
      );
  }
};
